export enum MerchantPlatformNames {
  Obelis = 'OBELIS',
  Xpay = 'XPAY',
}

export const MERCHANT_PLATFORMS_WITH_FULL_DETAILS = [MerchantPlatformNames.Obelis];

export const MERCHANT_PLATFORMS_WITH_MERCHANT_ID_ENABLED = [MerchantPlatformNames.Xpay];
